//Format date to short string for things like posts and comments
//Eg. 1h, 2d, 3w, 4m, 5y
export const shortTimeSince = (date) => {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  let interval = seconds / 31536000;
  if (interval > 1) {
    return `${Math.floor(interval)}y`;
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return `${Math.floor(interval)}mo`;
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return `${Math.floor(interval)}d`;
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return `${Math.floor(interval)}h`;
  }
  interval = seconds / 60;
  if (interval > 1) {
    return `${Math.floor(interval)}m`;
  }
  return `${Math.floor(seconds)}s`;
};

//Get shortened date suffix (st, nd, rd, th, etc)
export const getDateSuffix = (date) => {
  console.log(date);
  const day = date.getDate();
  const suffix = ["th", "st", "nd", "rd"][day % 10 > 3 ? 0 : (((day % 100) - (day % 10) !== 10) * day) % 10];
  return day + suffix;
};

//Return time of day (12:00am, 1:00pm, etc) from a UTC date WITHOUT converting to local timezone
export const getTimeOfDayLocalized = (date) => {
  return new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit", hour12: true, timeZone: "UTC" }).format(
    date
  );
};
